let PackagesItem = [
	{
		track: 'Junior',
		trackJunior: true,
		trackTitle: 'Junior Track',
		trackSubtitle: true,
		trackPrice: '0',
		runningString: true,
		trackButton: 'Register',
		trackLink: 'https://geekle.us/ticketfree/1721343900446x699059230841765900',
		// juniorTicket1Name: "Free Ticket",
		// juniorTicket1Price: "0.00",
		// juniorTicket1Link: "https://geekle.us/ticketfree/1684419531109x998420949885255700",
		// juniorTicket2Name: "+ Certificate",
		// juniorTicket2Price: "9.99",
		// juniorTicket2Link: "https://geekle.us/ticket/1699051262272x434038936238293000",
		// juniorTicket3Name: "+ Certificate & Recordings",
		// juniorTicket3Price: "15.99",
		// juniorTicket3Link: "https://geekle.us/ticket/1699052276762x800257793798176800",
	},
	{
		track: 'Full Access',
		trackFull: true,
		trackTitle: 'FULL ACCESS 🔥',
		trackSubtitle: 'ticket',
		runningString: true,
		trackPrice: '99',
		earlyBird: 'early birds price',
		trackDesc: '1',
		trackButton: 'Register',
		trackList1: 'DAY1 Access',
		trackLink: 'https://geekle.us/ticket/1684420052449x452336353671381000',
	},
	{
		track: 'Year',
		trackTitle: 'Year of Software Architecture ❤️',
		trackSubtitle: 'package',
		runningString: true,
		trackPrice: '149',
		earlyBird: 'one year access',
		trackDesc: '1',
		trackText: true,
		yearTrackText: true,
		trackText1: 'One Year Package',
		trackButton: 'Register',
		trackLink: 'https://geekle.us/ticket/1721342179231x672044432766271500',
	},
	{
		track: 'Premium',
		newPremium: true,
		trackTitle: 'GeekSummer Premium Membership',
		trackSubtitle: 'One Year Premium Membership',
		trackPriceApperance: 2,
		trackPrice: '199',
		trackText: true,
		// trackText1: "One Year Premium Membership",
		trackDesc: '1',
		trackButton: 'BUY',
		trackLink: 'https://geekle.us/ticket/1721288484155x292078953995960300',
		inverseColors: true,
	},
	{
		track: 'Unlimited',
		trackTitle: 'Unlimited Year Enterprise Package',
		trackSubtitle: 'YEAR ENTERPRISE PACKAGE',
		trackPriceApperance: 4,
		runningString: true,
		trackPrice: 'Ask Our Manager "Get Offer"',
		trackText: false,
		unlimited: true,
		trackText1: 'One Year Pass for up to 100 members',
		trackDesc: '1',
		trackButton: 'Get Offer',
		trackLink: 'enterprise',
		validDate: '9.06',
	},
	// {
	//     trackTitle: "TEAM-5",
	//     trackSubtitle: "YEAR GROUP PACKAGE",
	//     trackPriceApperance: 3,
	//     runningString: true,
	//     trackPrice: "999",
	//     trackText: true,
	//     trackText1: "One Year Pass for 5 team members",
	//     trackDesc: "1",
	//     trackButton: "BUY",
	//     trackLink: 'https://geekle.us/ticket/1694109810106x843614570263085000',
	// },
	// {
	//     trackMode: 'Halloween',
	//     trackTitle: "FRANKENSTEIN'S HALLOWEEN 3+1 PACK",
	//     trackSubtitle: true,
	//     trackPrice: "179",
	//     trackText: true,
	//     trackButton: "GRAB SPOOKY DEAL",
	//     trackLink: 'https://geekle.us/ticket/1698044453451x220433225697198100',
	// },
];

export default PackagesItem;
